import React, {useState} from "react";
import {Button, IconButton, Table, TableBody, TableCell, TableRow, Typography} from "@mui/material";
import {AddCircle as AddIcon, Delete as RemoveIcon} from "@mui/icons-material";
import {AddAppRoleDialog} from "../dialogs";
import {arrays, objects} from "@atttomyx/shared-utils";
import "./appRoleForm.css";

const AppRoleForm = (props) => {
    const { data, onChange } = props;
    const [ showAdd, setShowAdd ] = useState(false);

    const removeRole = (field) => {
        const modified = objects.deepCopy(data);
        const array = modified.roles;

        if (arrays.contains(array, field)) {
            arrays.removeFrom(array, field);

            modified.roles = array;
            onChange(modified);
        }
    };

    const addRole = (field) => {
        const modified = objects.deepCopy(data);
        const array = modified.roles;

        if (!arrays.contains(array, field)) {
            arrays.addTo(array, field);

            modified.roles = array;
            onChange(modified);
        }
    };

    const renderRole = (role) => {
        return <TableRow key={role}>
            <TableCell width="90%">
                {role}
            </TableCell>
            <TableCell width="10%">
                <IconButton
                    color="secondary"
                    title={"Remove " + role}
                    onClick={() => removeRole(role)}
                >
                    <RemoveIcon/>
                </IconButton>
            </TableCell>
        </TableRow>
    };

    return <div className="app-role-form">
        <Typography variant="h5">
            Roles
        </Typography>
        <Table size="small" cellPadding={0} cellSpacing={0} className="striped roles">
            <TableBody>
                {data.roles.map(renderRole)}
            </TableBody>
        </Table>
        <Button color="primary" variant="text" className="add-role"
                onClick={() => setShowAdd(true)}>
            <AddIcon/> Add Role
        </Button>
        {showAdd ?
            <AddAppRoleDialog
                onCancel={() => setShowAdd(false)}
                onAdd={(added) => {
                    addRole(added);
                    setShowAdd(false);
                }}
            /> : null}
    </div>
};

export default AppRoleForm;
